export const initPromoSlider = () => {
  const slider = document.querySelector('[data-promotions-slider]');
  if (!slider) {
    return;
  }
  const swiper = new Swiper(slider, {
    spaceBetween: 20,
    slidesPerView: 1.1,
    breakpoints: {
      577: {
        slidesPerView: 1.8,
      },
      769: {
        slidesPerView: 2.1,
      },
      921: {
        slidesPerView: 2.3,
      },
      1161: {
        slidesPerView: 2.8,
      },
      1441: {
        slidesPerView: 3.2,
      },
      1601: {
        slidesPerView: 3.8,
      },
    },
  });
};
